<template>
  <div class="d-flex">
    <v-autocomplete
        :menu-props="{ bottom: true, offsetY: true }"
        class="rounded-lg"
        :items="items"
        v-model="item"
        :label="label"
        item-text="name"
        item-value="value"
        :disabled="disabled"
        :multiple="multiple"
        :placeholder="placeholder"
        :return-object="false"
    ></v-autocomplete>
  </div>
</template>

<script>
export default {
  name: 'SupplierSelect',
  props: {
    value: {},
    label: {
      default: null
    },
    placeholder: {
      default: null
    },
    disabled: {
      default: false
    },
    multiple: {
      default: false
    }
  },
  data() {
    return {
      items: [],
      item: null
    };
  },
  computed: {
  },
  created() {
    this.getStores();
  },
  mounted(){
    this.setItem();
  },
  methods: {
    getStores() {
      this.request({
        url: this.endpoint(`main/supplier`),
        method: "get",
        success: data => {
          this.items = []
          for (let supplier of data) {
            this.items.push({
              'name': supplier.name,
              'value': supplier.id,
            })
          }
        }
      })
    },

    setItem() {
      if (this.value != this.item) this.item = this.value;
    }
  },
  watch: {
    value() {
      this.setItem();
    },
    item() {
      this.$emit("input", this.item);
    }
  }
};
</script>


<style lang="scss" scoped></style>